import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useOnboardingStepData() {
    const { data: onboardingStepOptions } = useQuery({
        queryKey: [QueryKey.ONBOARDING_SERVICES],
        queryFn: async () => {
            const response = await axios.get(route('v2.onboarding.services.get'));
            return response.data;
        },
        placeholderData: [],
    });

    return {
        onboardingStepOptions,
    };
}
